const ReadingMode = [
    { 
        id: 0, 
        name: "light",
        color1: " bg-grey-100 ",
        color2: " bg-grey-50 ",
        text: " text-grey-950 ",
    },
    { 
        id: 1, 
        name: "dark",
        color1: " bg-zinc-900 ",
        color2: " bg-zinc-800 ",
        text: " text-zinc-100 ",
        
    },
    { 
        id: 2, 
        name: "stone",
        color1: " bg-stone-300 ",
        color2: " bg-stone-200 ",
        text: " text-stone-800 ",
        
    },
    { 
        id: 3, 
        name: "pink",
        color1: " bg-rose-200 ",
        color2: " bg-rose-50 ",
        text: " text-stone-800 ",
        
    },
  
   
];

export default ReadingMode; 